export default "__VITE_ASSET__BOhdWnHB__"